// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--37395";
export var footerNavList = "footer-module--footerNavList--710e7";
export var footerNavListItem = "footer-module--footerNavListItem--76fab";
export var footerStyle = "footer-module--footerStyle--a5877";